import React,{useState} from 'react'
import Canvas from "../canvas/Canvas"

import thumb5 from '../images/thumb_05.jpg';
import thumb6 from '../images/thumb_06.jpg';
import thumb7 from '../images/thumb_07.jpg';
import thumb8 from '../images/thumb_08.jpg';
import thumb9 from '../images/thumb_09.jpg';
import thumb10 from '../images/thumb_10.jpg';
import thumb11 from '../images/thumb_11.jpg';

import img5 from '../images/5.png'
import img6 from '../images/6.png'
import img7 from '../images/7.png'
import img8 from '../images/8.png'
import img9 from '../images/9.png'
import img10 from '../images/10.png'
import img11 from '../images/11.png'

import {Modal} from 'react-bootstrap';
import "./modal.css";

export default function EyeAnatomy(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Anatomy");
    const [showImage,setShowImage] = useState(img5);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }

    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Eye Anatomy
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb5}  className="w-100 rounded" />
                                    <h6 className="text-muted ms-2 mt-2">Eye Front</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Anatomy - Eye Front",img5)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb6}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Eye 3/4</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Anatomy - Eye 3/4",img6)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 


                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb7}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Eye Profile</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Anatomy - Eye Profile",img7)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 


                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb8}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Cutaway 1</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Anatomy - Cutaway",img8)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb9}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Cutaway 2</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Anatomy - Cutaway",img9)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb10}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Cutaway 3</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Anatomy - Cutaway",img10)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        <div className="col-lg-2 mt-4">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img src={thumb11}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Fundus</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Anatomy - Fundus",img11)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 


                    </div>
                </div>
            </div>  
            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>           
        </>
    )
}